import { personalInformation } from '@/assets/infos/apply-form-infos/personalInformation';
import { education } from '@/assets/infos/apply-form-infos/education';
import { etc } from '@/assets/infos/apply-form-infos/etc';
// import { career } from '@/assets/infos/apply-form-infos/career';
// import { hopeArea } from '@/assets/infos/apply-form-infos/hopeArea';
// import { hopePath } from '@/assets/infos/apply-form-infos/hopePath';
// import { family } from '@/assets/infos/apply-form-infos/family';
// import { license } from '@/assets/infos/apply-form-infos/license';
// import { applicationMotive } from '@/assets/infos/apply-form-infos/applicationMotive';
import { opticalScienceApplicationMotive } from '@/assets/infos/apply-form-infos/opticalScienceApplicationMotive';
// import { meritsAndDemerits } from '@/assets/infos/apply-form-infos/meritsAndDemerits';
import { practicalTrainingProgramMotive } from '@/assets/infos/apply-form-infos/practicalTrainingProgramMotive';
  // import { aspiration } from '@/assets/infos/apply-form-infos/aspiration';
// import { rockyTime } from '@/assets/infos/apply-form-infos/rockyTime';

export const applyFormInfos = {
  sections: [
    'personalInformation',
    'education',
    'etc',
    // 'career',
    // 'hopeArea',
    // 'hopePath',
    // 'family',
    // 'license',
  ],
  introduceSections: [
    // 'applicationMotive',
    'opticalScienceApplicationMotive',
    'practicalTrainingProgramMotive',
    // 'meritsAndDemerits',
    // 'aspiration',
    // 'rockyTime',
  ],
  sectionItems: {
    personalInformation,
    education,
    etc,
    // career,
    // hopeArea,
    // hopePath,
    // family,
    // license,
    // applicationMotive,
    opticalScienceApplicationMotive,
    practicalTrainingProgramMotive,
    // meritsAndDemerits,
    // aspiration,
    // rockyTime,
  },
};